module.exports = __webpack_public_path__ + "assets/img/rankf.7677be5e.png";